<template>
  <div class="fin-percentage-change" :style="{color}">
    {{prepand}}
    <template v-if="!icon">
      <template v-if="!from">
        <span class="d-inline-block">
           {{ change | percent | isNaN }}
        </span>
      </template>
      <template v-else>
      <span v-if="change >= 0">
          <template
            v-if="absolute && !percentOnly">{{ absoluteValue }} ({{
              from | percentage(change)
            }}{{ ' ' + absoluteChangeText === null ? '' : absoluteChangeText }})</template>
          <template v-else-if="absolute && percentOnly">{{ from | percentage(change) }}</template>
          <template v-else>{{ from | percentage(change) }}</template>
      </span>
        <span v-else>
          <template v-if="absolute && !percentOnly">{{ absoluteValue }} ({{ from | percentage(change) }})x </template>
          <template v-else-if="absolute && percentOnly">{{ from | percentage(change) }}</template>
          <template v-else>{{ from | percentage(change) }}</template>
      </span>
      </template>
    </template>
    <template v-else>
      <v-icon>{{ iconType }}</v-icon>
    </template>
    {{append}}
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'finPercentageChange',
  props: {
    change: {
      type: Number
    },
    from: {
      type: Number
    },
    icon: {
      type: Boolean
    },
    absolute: {
      type: Boolean
    },
    absoluteFormat: {
      type: Function,
      default: Vue.options.filters.numberChange
    },
    absoluteChangeText: {
      type: String,
      default: 'Rendite'
    },
    textColor: {
      type: String,
      default: undefined
    },
    percentOnly: {
      type: Boolean
    },
    append: {
      type: String,
      default: ''
    },
    prepand: {
      type: String,
      default: ''
    },
  },
  computed: {
    color() {
      if (this.textColor !== undefined) return this.textColor
      if (this.change < 0) return this.$finColors.accentRed
      if (this.change > 0) return this.$finColors.accentGreen
      return this.$finColors.primaryDark
    },
    iconType() {
      if (this.change < 0) return 'icon-value-down'
      if (this.change > 0) return 'icon-value-up'
      return 'icon-ellipse-add'
    },
    absoluteValue() {
      if (!this.change) return '-'
      if (!this.absoluteFormat) return this.change
      return this.absoluteFormat(this.change)
    }
  }

}
</script>

<style scoped>

</style>
